let navigateToLogin = () => {};

export function setNavigateToLogin(fn) {
  navigateToLogin = fn;
}

export function goToLogin() {
  navigateToLogin();
}
